interface Props {
  [key: string]: any
}

export default function FullArrowDownIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 24 24" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M12.9182 16.006C12.4233 16.5418 11.5767 16.5418 11.0818 16.006L7.01002 11.5982C6.27046 10.7976 6.8383 9.5 7.92821 9.5L16.0718 9.5C17.1617 9.5 17.7295 10.7976 16.99 11.5982L12.9182 16.006Z"
        fill="#7D38D6"
      />
    </svg>
  )
}
